import Choices from 'choices.js';

export class SelectEditor {
  init(params) {
    this.params = params;
    this.selectedValue = params.value ?? '';

    this.eGui = document.createElement('div');
    this.eGui.classList.add('bg-white', 'border', 'border-gray-300', 'shadow-lg', 'rounded-md', 'p-1', 'min-w-[180px]');

    this.selectElement = document.createElement('select');
    this.eGui.appendChild(this.selectElement);

    const choices = (params.values || []).map(val => ({
      value: val,
      label: val === '' ? '(blank)' : val,
      selected: val === this.selectedValue
    }));

    this.choicesInstance = new Choices(this.selectElement, {
      choices,
      searchEnabled: false,
      shouldSort: false,
      allowHTML: false,
      itemSelectText: '',
      placeholder: false
    });

    this.selectElement.addEventListener('change', () => {
      this.selectedValue = this.choicesInstance.getValue(true);
      params.api.stopEditing();
    });

    this.eGui.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        params.api.stopEditing(true);
      }
    });
  }

  getGui() {
    return this.eGui;
  }

  afterGuiAttached() {
    this.choicesInstance.showDropdown();
  }

  getValue() {
    return this.selectedValue;
  }

  isPopup() {
    return true;
  }

  isCancelBeforeStart() {
    return false;
  }

  isCancelAfterEnd() {
    return false;
  }

  destroy() {
    if (this.choicesInstance) {
      this.choicesInstance.destroy();
      this.choicesInstance = null;
    }
  }
}
